// extracted by mini-css-extract-plugin
export default {"root":"FileViewer_root__Omj7S","content":"FileViewer_content__+EMO3"};